import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { pageTitle } from "@/components/document-title";
import { VehicleDetailPage } from "@/features/vehicles/pages/vehicle-detail-page/vehicle-detail-page";
import { vehicleDetailSearchSchema } from "@/features/vehicles/schemas/vehicle-detail-search.schema";

export const Route = createFileRoute(
	"/_authenticated/admin/vehicles/$vehicleId"
)({
	head: () => pageTitle("Vehicle"),
	validateSearch: zodValidator(vehicleDetailSearchSchema),
	component: VehicleDetailPage,
});
